import { PHONE, PhoneNumbersView } from '@elva/ui';
import { useWorkspaceLabel } from '@elva/platform';

/** Settings · Practice management › Phone numbers (spec 16 §4). */
export function SettingsPhoneNumbersPage() {
  return <PhoneNumbersView data={PHONE} location={useWorkspaceLabel()} />;
}
